import React, { useEffect, useState } from "react";
import { profilePhotos } from "../../content/profilePhotos";

function ProfileSlideshow() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [reduceMotion, setReduceMotion] = useState(false);
  const photoCount = profilePhotos.length;

  useEffect(() => {
    if (!window.matchMedia) {
      return undefined;
    }

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mediaQuery) {
      return undefined;
    }

    setReduceMotion(mediaQuery.matches);
    const handleChange = (event) => setReduceMotion(event.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    if (photoCount <= 1 || reduceMotion) {
      return undefined;
    }

    const interval = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % photoCount);
    }, 5000);

    return () => window.clearInterval(interval);
  }, [photoCount, reduceMotion]);

  const goToSlide = (index) => setActiveIndex(index);
  const goToPrevious = () =>
    setActiveIndex((current) => (current - 1 + photoCount) % photoCount);
  const goToNext = () => setActiveIndex((current) => (current + 1) % photoCount);

  return (
    <div className="profile-slideshow" aria-label="Profile photo slideshow">
      <div className="profile-slideshow-frame">
        {profilePhotos.map((photo, index) => (
          <img
            key={`${photo.location}-${index}`}
            src={photo.src}
            alt={photo.alt}
            className={`profile-slide${
              index === activeIndex ? " profile-slide-active" : ""
            }`}
            width="450"
            height="450"
            loading={index === 0 ? "eager" : "lazy"}
          />
        ))}

        {photoCount > 1 && (
          <>
            <button
              type="button"
              className="profile-slide-control profile-slide-prev"
              onClick={goToPrevious}
              aria-label="Previous photo"
            >
              ‹
            </button>
            <button
              type="button"
              className="profile-slide-control profile-slide-next"
              onClick={goToNext}
              aria-label="Next photo"
            >
              ›
            </button>
          </>
        )}
      </div>

      {photoCount > 1 && (
        <div className="profile-slide-dots" role="tablist" aria-label="Choose photo">
          {profilePhotos.map((photo, index) => (
            <button
              key={`dot-${photo.location}-${index}`}
              type="button"
              role="tab"
              aria-selected={index === activeIndex}
              aria-label={`Show photo from ${photo.location}`}
              className={`profile-slide-dot${
                index === activeIndex ? " profile-slide-dot-active" : ""
              }`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}

      {profilePhotos[activeIndex]?.location && (
        <p className="profile-slide-caption">
          {profilePhotos[activeIndex].location}
        </p>
      )}
    </div>
  );
}

export default ProfileSlideshow;
